<template>
  <div
    class="signup-block column is-9 is-offset-1 mt-6 mb-6 has-margin-left-10-mobile has-margin-right-10-mobile"
  >
    <div class="container">
      <div class="row">
        <div class="cardbox overflow-hidden columns rounded-3 px-0 py-0">
          <div class="column is-6 px-0 py-0">
            <div class="img-wrap">
              <SignUpImage />
            </div>
          </div>
          <div class="column is-6">
            <div class="signup-wrap">
              <EnterPassword :jobseeker="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SignUpImage from '~/components/Accounts/SignUp/SignUpImage.vue'
import EnterPassword from '~/components/Accounts/SignUp/EnterPassword.vue'
export default {
  components: {
    SignUpImage,
    EnterPassword
  },
  mounted() {
    if (this.$auth.loggedIn === true) {
      this.$router.push(
        this.localePath({
          name: 'index'
        })
      )
    }
  }
}
</script>
